<!-- Card Reviews -->
<div
  class="card-reviews"
  [class]="
    backgroundInfo && backgroundInfo.url ? textColorOverride + 'bg-no-repeat bg-center bg-cover' : backgroundInfo
  "
  [style.backgroundImage]="backgroundInfo && backgroundInfo.url && 'url(' + backgroundInfo.url + ')'"
  >
  <div class="container wysiwyg {{ containerClasses }}" [class.!px-v-spacing]="containerClasses?.length === 0">
    @if (title) {
      <div class="wysiwyg sm:px-v-spacing max-w-container mx-auto" [innerHTML]="title"></div>
    }
    <div class="flex flex-col md:flex-row items-baseline">
      @for (review of cardReviews; track review; let last = $last) {
        <div
          class="w-auto md:w-1/3 flex-col py-v-spacing sm:px-v-spacing mb-v-spacing bg-white rounded border"
          [class.md:mr-v-spacing]="!last"
          >
          <div class="reviewer-img">
            <img
              class="rounded-full mx-auto"
              width="100"
              height="100"
              [src]="review.image.src"
              [alt]="review.image.altText ? review.image.altText : ''"
              />
          </div>
          <div class="text-center text-ace-teal-600 py-v-spacing">{{ review.name }}</div>
          <p class="italic font-light text-vis-regular">{{ review.review }}</p>
        </div>
      }
    </div>
  </div>
</div>
